import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import CustomerView from '../../components/Customer/CustomerView';

const SalesOrderViewPage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <CustomerView/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};

export default SalesOrderViewPage;